import { Expose } from "class-transformer";

export class RemovePlanningBoardProjectDto {
  @Expose()
  planningBoardProjectId: string;
}
